import { useState } from 'react';
import IconButton from '@savvy-kit/components/icon-button';
import { Popover, PopoverContent, PopoverTrigger } from '@savvy-kit/components/popover';
import { ToggleGroup, ToggleGroupItem } from '@savvy-kit/components/toggle-group';
import { Text } from '@savvy-kit/foundations/text';
import { Ellipsis, Eye, Wallet } from 'lucide-react';

import { textColors } from '@savvy/deprecated-shared/theme';

export function NetWorthItemMenu({
  advisorView,
  hiddenFromClient,
  hiddenFromNetWorth,
  isManagedAccount,
  handleChange,
  setHiddenFromClient,
  setHiddenFromNetWorth,
}: {
  readonly advisorView?: boolean;
  readonly hiddenFromClient: boolean;
  readonly hiddenFromNetWorth: boolean;
  readonly isManagedAccount: boolean;
  readonly handleChange: (field: 'hiddenFromNetWorth' | 'hiddenFromClient', value: boolean) => void;
  readonly setHiddenFromClient: (value: boolean) => void;
  readonly setHiddenFromNetWorth: (value: boolean) => void;
}) {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <Popover open={menuOpen} onOpenChange={setMenuOpen}>
        <PopoverTrigger
          render={
            <IconButton
              variant="ghost"
              className="align-top"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
              }}
            >
              <Ellipsis />
            </IconButton>
          }
        />
        <PopoverContent side="bottom" align="end" sideOffset={0} className="w-auto p-0">
          <div className="flex flex-col gap-4 py-4">
            {advisorView && !isManagedAccount && (
              <div className="flex flex-row gap-2 items-center justify-between px-6">
                <div className="flex flex-row gap-0">
                  <Eye className="text-secondary" />
                  <Text color="dark" className="px-4">
                    Visible to client?
                  </Text>
                </div>
                <ToggleGroup
                  onValueChange={([next]) => {
                    if (next === undefined) {
                      return;
                    }
                    const value = next === 'yes';
                    setHiddenFromClient(!value);
                    handleChange('hiddenFromClient', value);
                  }}
                  value={!hiddenFromClient ? ['yes'] : ['no']}
                >
                  <ToggleGroupItem value="yes">Yes</ToggleGroupItem>
                  <ToggleGroupItem value="no">No</ToggleGroupItem>
                </ToggleGroup>
              </div>
            )}
            {!hiddenFromClient && (
              <div className="flex flex-row gap-2 items-center justify-between px-6">
                <div className="flex flex-row gap-0">
                  <Wallet color={textColors.secondary} />
                  <Text color="dark" className="px-4">
                    Include in net worth?
                  </Text>
                </div>
                <ToggleGroup
                  onValueChange={([next]) => {
                    if (next === undefined) {
                      return;
                    }
                    const value = next === 'yes';
                    setHiddenFromNetWorth(!value);
                    handleChange('hiddenFromNetWorth', value);
                  }}
                  value={!hiddenFromNetWorth ? ['yes'] : ['no']}
                >
                  <ToggleGroupItem value="yes">Yes</ToggleGroupItem>
                  <ToggleGroupItem value="no">No</ToggleGroupItem>
                </ToggleGroup>
              </div>
            )}
          </div>
        </PopoverContent>
      </Popover>
    </div>
  );
}
